import { createContext, useContext } from "react";
import { RoomType } from "sendbird-calls";
import { initialState } from "./sendbird-calls/SbCallsContext/state";
export function requestMediaPermissions(ref) {
  navigator.mediaDevices
    .getUserMedia({ video: true, audio: true })
    .then(function (stream) {
      ref.current = stream;
    })
    .catch(function (error) {});
}
const stub = () => {
  throw new Error("You forgot to wrap your component in <AuthContext>.");
};
/** State */
export const initialContext = {
  ...initialState,
  isAuthenticated: false,
  init: stub,
  auth: stub,
  deauth: stub,

  // Media Device Control
  updateMediaDevices: stub,
  selectAudioInputDevice: stub,
  selectAudioOutputDevice: stub,
  selectVideoInputDevice: stub,

  // Direct Calls
  isBusy: false,
  currentCall: undefined,
  dial: stub,
  addDirectCallSound: stub,
  clearCalls: stub,

  // Rooms
  createRoom: stub,
  getCachedRoomById: stub,
  fetchRoomById: stub,
  RoomType: RoomType,
};

export const CallContext = createContext(initialContext);
export const useSbCalls = () => useContext(CallContext);
